import { createContext } from 'react'

export interface SelectedFeederState {
  /** The feeder currently selected anywhere in the app, or null. */
  selectedFeederId: number | null
  setSelectedFeederId: (id: number | null) => void
}

export const SelectedFeederContext = createContext<SelectedFeederState>({
  selectedFeederId: null,
  setSelectedFeederId: () => {},
})
